import axios from "axios";
import React from "react";
import "./navbar.scss";
const Navbar = ({setuser}) => {
  const handleLogout = async()=>{
    const {data} = await axios.get("/api/logout",{withCredentials:true});
    setuser({user:null,isAuthenticated:false})
  }
  return (
    <div className="navbar">
      <div className="logo">
        <span>Action Plan</span>
      </div>
      <div className="log-out">
        <button onClick={handleLogout}>LOG OUT</button>
      </div>
    </div>
  );
};

export default Navbar;
